<template>
  <el-carousel  class="v-carousel" 
                :class="size"
                :initial-index="initialIndex"
                :trigger="trigger"
                :autoplay="autoplay"
                :interval="interval"
                :indicator-position="indicatorPosition"
                :arrow="arrow"
                :type="type"
                :loop="loop"
                :direction="direction">
    <el-carousel-item  
                       v-for="(item,index) in carouselVal.card.carditem" 
                       :key="index"
                       class="imgOne">
       <img class="carouselImg" :src="address+item.img"  :class="item.url!==''&&item.url!==null?'click size':'size'" @click="linkUrl(item.url)"/>
       <h3 class="content" v-if="item.txt!==''" v-html="item.txtType=='markdown'?mark(item.txt):item.txt" @click="linkUrl(item.url)"></h3>
    </el-carousel-item>
  </el-carousel>
</template>

<script>
import marked from 'marked'
export default {
  name: 'v-carousel',
  props: {
      carouselVal: null //这样可以指定传入的类型，如果类型不对，会警告
  },
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      // address:"http://10.16.54.158:9018",
      address:"",
      size:"small",//走马灯的高度
      initialIndex:0,//初始状态激活的幻灯片的索引，从 0 开始 默认0
      trigger:"",//指示器的触发方式 默认- click
      autoplay:true,//是否自动切换 默认true
      interval:3000,//自动切换的时间间隔，单位为毫秒 默认true
      indicatorPosition:"",//	指示器的位置 默认outside/none/-
      arrow:"hover",//切换箭头的显示时机 always/hover/never 默认hover
      type:"",//走马灯的类型 默认- card
      loop:true,//是否循环显示 默认true
      direction:"horizontal",//走马灯展示的方向 horizontal/vertical
    }
  },
  created(){
    var that =this;
    that.size = that.getAttr(that.carouselVal.card.attr,"size")?that.getAttr(that.carouselVal.card.attr,"size"):"3rem";
    that.trigger = that.getAttr(that.carouselVal.card.attr,"trigger")?that.getAttr(that.carouselVal.card.attr,"trigger"):"";
    that.autoplay = that.getAttr(that.carouselVal.card.attr,"autoplay")?that.getAttr(that.carouselVal.card.attr,"autoplay"):true;
    that.interval = that.getAttr(that.carouselVal.card.attr,"interval")?that.getAttr(that.carouselVal.card.attr,"interval"):3000;
    that.indicatorPosition = that.getAttr(that.carouselVal.card.attr,"indicator-position")?that.getAttr(that.carouselVal.card.attr,"indicator-position"):"";
    that.type = that.getAttr(that.carouselVal.card.attr,"type")?that.getAttr(that.carouselVal.card.attr,"type"):"";
    that.loop = that.getAttr(that.carouselVal.card.attr,"loop")?that.getAttr(that.carouselVal.card.attr,"loop"):true;
    that.direction = that.getAttr(that.carouselVal.card.attr,"direction")?that.getAttr(that.carouselVal.card.attr,"direction"):"horizontal";

  },
  methods:{
     //跳转链接
    linkUrl(_url){
      var that = this;
      if(_url!==""&&_url!==null){
        if(_url.indexOf("http")>=0||_url.indexOf("https")>=0){
          window.open(_url);
        }else{
          that.$router.push({'name':'build',query:{"id":_url}});
        }
      }
      return;
    },
    //转换md格式
    mark(_value){
      return marked(_value);
    },
    //转换样式
    getAttr(_attr,_type){
      var data={};
      if(_attr!==''){
        data=JSON.parse(_attr);
        return data.[_type];
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  scoped>

</style>
